export default {
  titulo: 'Documetos recibidos',
  campos: ['EstadosEmision', 'MontoTotal', 'Documento', 'TrackId', 'FechaEnvioSii', 'FechaEmision'],
  acccionesIndividuales: ['Bitacora', 'EnviarAprobacion', 'VerReferencias', 'AsociarDocumento', 'DescargarPdf', 'DescargarXml', 'EnviarDte', 'RecuperarCorreoSii', 'ModificarTipoVenta', 'CopiarDocumento', 'AyudaEnDocumento'],
  accionesMasivas: [],
  seleccionMasiva: true,
};
